const LANGUAGE_ENGLISH = "LANGUAGE_ENGLISH";
const LANGUAGE_CHINESE = "LANGUAGE_CHINESE";

const LANGUAGES = {
  ENGLISH: LANGUAGE_ENGLISH,
  CHINESE: LANGUAGE_CHINESE
};

const LANGUAGE_LABELS = {
  [LANGUAGE_ENGLISH]: "language.english",
  [LANGUAGE_CHINESE]: "language.chinese"
};

export { LANGUAGES, LANGUAGE_LABELS };
